export const text = [
    {
        summary: 'Where is it?',
        details: [
            {
                summary: 'Hidden in the garden',
                details: [
                    {
                        summary: 'Is it really long?',
                        details: [
                            "Green and bright with those little black eyes",
                        ],
                    },
                    {
                        summary: 'Is it a snake?',
                        details: [
                            "What else could it be? It looks like it to me.",
                        ],
                    },
                    {
                        summary: 'Take it somewhere else',
                        details: [
                            {
                                summary: 'The Alley',
                                details: [
                                    "The poor thing. It's so cold out here.",
                                ],
                            },
                            {
                                summary: 'The Beach',
                                details: [
                                    "The poor thing. It's so hot out here.",
                                ],
                            },
                            {
                                summary: 'The Forest',
                                details: [
                                    "I think it's happy here.",
                                ],
                            },
                        ],
                    },
                ],
            },
        ]
    }
];

export default text;